<div class="consent-banner-wrapper" *ngIf="showCookieConsentBanner$ | async">
  <div class="consent-banner-content">
    <div class="consent-banner-text-section">
      <div *ngIf="currentLang$ | async as lang" class="consent-banner-text-content">
        <ng-container *ngIf="bannerLayer === 'main'">
          <div>{{ 'consent.mainLayer.hi' | translate }}</div>
          <div
            *ngFor="let row of 'consent.mainLayer.paragraphs' | translate"
            [innerHTML]="row"
          ></div>
          <div
            [innerHTML]="
              'consent.mainLayer.fourthParagraph'
                | translate
                  : {
                      value: {
                        dataProtectionPolicyUrl:
                          assetMap.consent.dataProtectionPolicyUrl(lang),
                        dataOwner: assetMap.consent.dataOwner
                      }
                    }
            "
          ></div>
        </ng-container>
        <ng-container [formGroup]="consentForm" *ngIf="bannerLayer === 'detailed'">
          <div
            *ngFor="let row of 'consent.secondLayer.paragraphs' | translate"
            [innerHTML]="row"
          ></div>
          <div
            [innerHTML]="
              'consent.secondLayer.thirdParagraph'
                | translate
                  : {
                      value: {
                        dataProtectionPolicyUrl:
                          assetMap.consent.dataProtectionPolicyUrl(lang)
                      }
                    }
            "
          ></div>
          <div class="consent-banner-text-content">
            <div class="consent-banner-text-content-bold">
              {{ 'consent.secondLayer.necessaryHeader' | translate }}
            </div>
            <div>
              {{ 'consent.secondLayer.necessaryParagraph' | translate }}
            </div>
            <div *ngIf="!showNecessary">
              <a (click)="showNecessary = true" class="consent-banner-text-content-bold"
                >[{{ 'consent.secondLayer.more' | translate }}]</a
              >
            </div>
            <div class="grid grid-cols-2" *ngIf="showNecessary">
              <div class="grid-item">{{ 'consent.secondLayer.name' | translate }}</div>
              <div class="grid-item">
                {{ 'consent.secondLayer.description' | translate }}
              </div>
              <div class="grid-item">
                {{ 'consent.secondLayer.amazonCookieName' | translate }}
              </div>
              <div class="grid-item span-row-3 items-center">
                {{ 'consent.secondLayer.necessaryCookieDescription' | translate }}
              </div>
              <div class="grid-item">
                {{ 'consent.secondLayer.cdn77CokieName' | translate }}
              </div>

              <div class="grid-item">
                {{ 'consent.secondLayer.stripeCookieName' | translate }}
              </div>
            </div>
          </div>
          <div class="consent-banner-text-content">
            <div class="consent-banner-text-content-bold">
              {{ 'consent.secondLayer.analyticsHeader' | translate }}
            </div>
            <div>
              {{ 'consent.secondLayer.analyticsParagraph' | translate }}
            </div>
            <div *ngIf="!showAnalytics">
              <a (click)="showAnalytics = true" class="consent-banner-text-content-bold"
                >[{{ 'consent.secondLayer.adjustConsent' | translate }}]</a
              >
            </div>
            <ng-container *ngIf="showAnalytics">
              <div class="grid grid-cols-3-or-4 tablet-visible">
                <div class="grid-item">{{ 'consent.secondLayer.name' | translate }}</div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.description' | translate }}
                </div>
                <div class="grid-item tablet-visible">
                  {{ 'consent.secondLayer.duration' | translate }}
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.consent' | translate }}
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.bamlCookieName' | translate }}
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.bradmaxBamlCookieDescription' | translate }}
                </div>
                <div class="grid-item tablet-visible">
                  {{ 'consent.secondLayer.oneYear' | translate }}
                </div>
                <div class="grid items-center grid-item span-row-3">
                  <tui-toggle size="l" formControlName="bradmax"></tui-toggle>
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.bameCookieName' | translate }}
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.bradmaxBameCookieDescription' | translate }}
                </div>
                <div class="grid-item tablet-visible">
                  {{ 'consent.secondLayer.oneYear' | translate }}
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.bamcdcCookieName' | translate }}
                </div>
                <div class="grid-item">
                  {{ 'consent.secondLayer.bradmaxBamcdcCookieDescription' | translate }}
                </div>
                <div class="grid-item tablet-visible">
                  {{ 'consent.secondLayer.oneYear' | translate }}
                </div>
              </div>
              <div class="grid grid-cols-3-or-4">
                <div class="grid-item">
                  {{ 'consent.secondLayer.googleAnalyticsCookieName' | translate }}
                </div>
                <div class="grid-item">
                  {{
                    'consent.secondLayer.googleAnalyticsStorageCookieDescription'
                      | translate
                  }}
                </div>
                <div class="grid-item tablet-visible">
                  {{ 'consent.secondLayer.visitTime' | translate }}
                </div>
                <div class="grid-item grid items-center">
                  <tui-toggle size="l" formControlName="googleAnalytics"></tui-toggle>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="consent-banner-text-content">
            <div class="consent-banner-text-content-bold">
              {{ 'consent.secondLayer.marketingHeader' | translate }}
            </div>
            <div>
              {{ 'consent.secondLayer.marketingParagraph' | translate }}
            </div>
            <div *ngIf="!showMarketing">
              <a (click)="showMarketing = true" class="consent-banner-text-content-bold"
                >[{{ 'consent.secondLayer.adjustConsent' | translate }}]</a
              >
            </div>
            <div class="grid grid-cols-3-or-4" *ngIf="showMarketing">
              <div class="grid-item">{{ 'consent.secondLayer.name' | translate }}</div>
              <div class="grid-item">
                {{ 'consent.secondLayer.description' | translate }}
              </div>
              <div class="grid-item tablet-visible">
                {{ 'consent.secondLayer.duration' | translate }}
              </div>
              <div class="grid-item">{{ 'consent.secondLayer.consent' | translate }}</div>
              <div class="grid-item">
                {{ 'consent.secondLayer.googleAdPersonalizationCookieName' | translate }}
              </div>
              <div class="grid-item">
                {{
                  'consent.secondLayer.googleMarketingAdPersonalizationCookieDescription'
                    | translate
                }}
              </div>
              <div class="grid-item tablet-visible">
                {{ 'consent.secondLayer.oneYear' | translate }}
              </div>
              <div class="grid-item grid items-center">
                <tui-toggle
                  formControlName="googleMarketingPersonalization"
                  size="l"
                ></tui-toggle>
              </div>
              <div class="grid-item">
                {{ 'consent.secondLayer.googleAdStorageCookieName' | translate }}
              </div>
              <div class="grid-item">
                {{
                  'consent.secondLayer.googleMarketingAdStorageCookieDescription'
                    | translate
                }}
              </div>
              <div class="grid-item tablet-visible">
                {{ 'consent.secondLayer.oneYear' | translate }}
              </div>
              <div class="grid-item grid items-center">
                <tui-toggle
                  formControlName="googleMarketingAdStorage"
                  size="l"
                ></tui-toggle>
              </div>
              <div class="grid-item">
                {{ 'consent.secondLayer.googleAdUserDataCookieName' | translate }}
              </div>
              <div class="grid-item">
                {{
                  'consent.secondLayer.googleMarketingAdUserDataCookieDescription'
                    | translate
                }}
              </div>
              <div class="grid-item tablet-visible">
                {{ 'consent.secondLayer.oneYear' | translate }}
              </div>
              <div class="grid-item grid items-center">
                <tui-toggle
                  formControlName="googleMarketingAdUserData"
                  size="l"
                ></tui-toggle>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="consent-banner-buttons">
      <button (click)="acceptAll()" tuiButton appearance="outline" size="m">
        {{ 'consent.mainLayer.accept' | translate }}
      </button>

      <button (click)="denyAll()" tuiButton appearance="outline" size="m">
        {{ 'consent.mainLayer.deny' | translate }}
      </button>
      <button
        *ngIf="bannerLayer === 'detailed'"
        (click)="acceptSelected()"
        tuiButton
        appearance="outline"
        size="m"
      >
        {{ 'consent.secondLayer.save' | translate }}
      </button>
      <button
        *ngIf="bannerLayer === 'main'"
        tuiButton
        appearance="outline"
        size="m"
        (click)="showDetailedLayer()"
      >
        {{ 'consent.mainLayer.settings' | translate }}
      </button>
    </div>
  </div>
</div>
